import { render } from "./ChartComponent.vue?vue&type=template&id=86a4a548&scoped=true"
import script from "./ChartComponent.vue?vue&type=script&lang=js"
export * from "./ChartComponent.vue?vue&type=script&lang=js"

import "./ChartComponent.vue?vue&type=style&index=0&id=86a4a548&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a4a548"]])

export default __exports__